import Div from "@jumbo/shared/Div/Div";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import "./PreviewFormSelected.css";
import Typography from "@mui/material/Typography";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {del} from "../../../common/network";
import {contactFormCodes} from "../../../constants";
import DeleteModal from "../modal-preview/DeleteModal";


const PreviewGeneratedFormsSelected = ({upperSectionProps, setUpperSectionProps, lowerSectionProps, setSelectedForm, selectedMatter, setSelectedMatter, fetchExistingFormData, upperSectionItems, checkedForms, setCheckedForms, checkedDockets, setCheckedDockets}) => {
    const navigate = useNavigate();

    const [upperSelectedItems, setUpperSelectedItems] = useState(upperSectionProps.selectedDocket);
    const [lowerSelectedItems, setLowerSelectedItems] = useState(upperSectionProps.selectedForm);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteMatterId, setDeleteMatterId] = useState(null);
    const [deleteFormId, setDeleteFormId] = useState(null);
    const [renderDocketsFirstTime, setRenderDocketsFirstTime] = useState(true);
    const [renderItemsFirstTime, setRenderItemsFirstTime] = useState(true);

    // Update component when selectedForm changes
    useEffect(() => {
        setUpperSectionProps(upperSectionItems);
    }, []);

    useEffect(() => {
        setUpperSelectedItems(upperSectionProps.selectedDocket);
    }, [upperSectionProps?.selectedDocket]);

    useEffect(() => {
        setLowerSelectedItems(upperSectionProps.selectedForm);
    }, [upperSectionProps?.selectedForm]);

    const handleDelete = (matter_id, form_id) => {
        setDeleteModalOpen(true);
        setDeleteMatterId(matter_id);
        setDeleteFormId(form_id);
    };

    const deleteForms = async (matter_id, form_id) => {
        setDeleteLoading(true);
        try {
            const selectedIds = [];
            if (matter_id) {
                for (const item of upperSectionProps?.selectedItems?.[matter_id]) {
                    if (contactFormCodes.includes(item.form_code)) {
                        const response = await fetchExistingFormData(item.id, matter_id, "Draft", true);
                        if (response?.data?.length > 0) {
                            response.data.forEach(data => selectedIds.push(data.id));
                        }
                    } else {
                        const response = await fetchExistingFormData(item.id, matter_id, "Draft");
                        if (response?.data) {
                            selectedIds.push(response.data.id);
                        }
                    }

                }
            }

            if (form_id) {
                const requiredIds = upperSectionProps?.selectedItems?.[selectedMatter]?.map(item => contactFormCodes.includes(item.form_code) ? item.id : false)?.filter(Boolean);
                if (requiredIds.includes(form_id)) {
                    const response = await fetchExistingFormData(form_id, selectedMatter, "Draft", true);
                    if (response?.data?.length > 0) {
                        response.data.forEach(data => selectedIds.push(data.id));
                    }
                } else {
                    const response = await fetchExistingFormData(form_id, selectedMatter, "Draft");
                    if (response?.data) {
                        selectedIds.push(response.data.id);
                    }
                }
            }

            if (selectedIds.length > 0) {
                const response = await del(`docgen/generate-forms`, {
                    formIds: selectedIds
                });

                if (response?.success === true) {

                    if (matter_id) {
                        setUpperSectionProps((prevState) => {
                            const newState = {...prevState};
                            newState.selectedDockets = newState?.selectedDockets?.filter((item) => item.id !== matter_id);
                            delete newState.selectedItems[matter_id];
                            return newState;
                        });
                        toast.success("Docket has been deleted along with all corresponding forms");
                    }
                    if (form_id) {
                        setUpperSectionProps((prevState) => {
                            const newState = {...prevState};
                            newState.selectedItems[selectedMatter] = newState?.selectedItems?.[selectedMatter]?.filter((item) => item.id !== form_id);
                            return newState;
                        });
                        toast.success("Generated form deleted");
                    }
                    setCheckedDockets({});
                    setCheckedForms({});
                }
            } else {
                toast.error("File cannot be deleted since it does not exist or has been already completed");
            }
        } catch (error) {
        } finally {
            setDeleteLoading(false);
            setConfirmDelete(null);
        }

    };

    useEffect(() => {
        if (confirmDelete) {
            deleteForms(deleteMatterId, deleteFormId);
        }
    }, [confirmDelete]);

    useEffect(() => {
        if (upperSectionProps?.selectedItems?.[selectedMatter]) {
            if (upperSectionProps.selectedItems?.[selectedMatter]?.length === 0) {
                setUpperSectionProps((prevState) => {
                    const newMatterList = prevState?.selectedDockets?.filter((item) => item.id !== selectedMatter);
                    return ({...prevState, selectedDockets: newMatterList});
                });
            } else {
                if (!renderItemsFirstTime) {
                    setUpperSectionProps((prevState) => ({...prevState, selectedForm: upperSectionProps?.selectedItems?.[selectedMatter]?.[0].id}));
                    setSelectedForm(upperSectionProps?.selectedItems?.[selectedMatter]?.[0]?.id);
                    setLowerSelectedItems(upperSectionProps?.selectedItems?.[selectedMatter]?.[0]?.id);
                }
                setRenderItemsFirstTime(false);
            }
        }
    }, [upperSectionProps?.selectedItems?.[selectedMatter]]);

    useEffect(() => {
        if (upperSectionProps?.selectedDockets?.length === 0) {
            navigate("/docgen/drafts");
        } else {
            if (!renderItemsFirstTime) {
                setUpperSectionProps((prevState) => ({...prevState, selectedDocket: upperSectionProps?.selectedDockets?.[0].id}));
                setSelectedMatter(upperSectionProps?.selectedDockets?.[0].id);
                setUpperSelectedItems(upperSectionProps?.selectedDockets?.[0].id);
            }

            if (renderDocketsFirstTime) {
                setRenderDocketsFirstTime(false);
            }
        }
    }, [upperSectionProps?.selectedDockets, renderDocketsFirstTime]);

    useEffect(() => {
        if (Object.keys(checkedForms?.[selectedMatter] || {})?.some(form => checkedForms?.[selectedMatter]?.[form])) {
            setCheckedDockets((prevState) => ({...prevState, [selectedMatter]: true}));
        } else {
            setCheckedDockets((prevState) => ({...prevState, [selectedMatter]: false}));
        }
    }, [checkedForms]);

    return (
        <Div className="pfs-wrapper">
            <Div
                sx={{
                    maxHeight: lowerSectionProps ? "50% !important" : "100% !important",
                    height: "auto"
                }}
                className="pfs-wrapper-1 pfs-wrapper-item"
            >
                <div className="heading-area">
                    <Typography
                        component={"h4"}
                        sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textAlign: "center",
                            padding: "10px"
                        }}
                    >
                        {upperSectionProps.title}
                    </Typography>
                </div>
                <div className="pfs-area customize-scrollbar">
                    {
                        // selectedItems CONTAINS THE LIST OF THE SELECTED ROWS
                        upperSectionProps.selectedDockets?.map((item, index) => {
                            return (
                                <>
                                    <Box key={item.id} sx={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                                        <Checkbox
                                            size="small"
                                            checked={checkedDockets[item.id] || false}
                                            indeterminate={checkedDockets[item.id] &&
                                                Object.keys(checkedForms?.[item.id] || {})
                                                      ?.filter(key => checkedForms?.[item.id]?.[key])?.length !== upperSectionProps?.selectedItems?.[item.id]?.length
                                            }
                                            onChange={(e) => {
                                                setCheckedDockets((prevState) => ({...prevState, [item.id]: !prevState[item.id]}));
                                                if (e.target.checked) {
                                                    setUpperSectionProps((prevState) => ({...prevState, selectedDocket: upperSectionProps?.selectedDockets[index].id}));
                                                    setUpperSelectedItems(upperSectionProps?.selectedDockets[index]?.id);
                                                    setSelectedMatter(upperSectionProps?.selectedDockets[index]?.id);
                                                    setCheckedForms((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            [item.id]: upperSectionProps?.selectedItems?.[item.id]?.reduce((acc, form) => {
                                                                acc[form.id] = true;
                                                                return acc;
                                                            }, {})
                                                        };
                                                    });
                                                } else {
                                                    setCheckedForms((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            [item.id]: upperSectionProps?.selectedItems?.[item.id]?.reduce((acc, form) => {
                                                                acc[form.id] = false;
                                                                return acc;
                                                            }, {})
                                                        };
                                                    });
                                                }
                                            }}
                                        />
                                        <Box
                                            className={`customize-chip text-center ${
                                                upperSectionProps?.setColor ? upperSectionProps.setColor : ""
                                            } ${upperSelectedItems === item.id ? "selected" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setUpperSectionProps((prevState) => ({...prevState, selectedDocket: upperSectionProps?.selectedDockets[index].id}));
                                                setUpperSelectedItems(upperSectionProps?.selectedDockets[index]?.id);
                                                setSelectedMatter(upperSectionProps?.selectedDockets[index]?.id);
                                            }}
                                            sx={{p: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "left"}}
                                        >
                                            {item.host_file_number}
                                            <Box flexGrow={1}/>
                                            <span
                                                style={{color: upperSelectedItems === item.id ? "white" : "black"}}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDelete(item.id, null);
                                                }}
                                            >
                                                X
                                            </span>
                                        </Box>
                                    </Box>
                                </>
                            );
                        })
                    }
                </div>
            </Div>
            {lowerSectionProps && (
                <Div
                    sx={{
                        maxHeight: "50% !important",
                        height: "auto"
                    }}
                    className="pfs-wrapper-2 pfs-wrapper-item"
                >
                    <div className="heading-area">
                        <Typography
                            component="h4"
                            sx={{
                                fontSize: "16px",
                                fontWeight: "500",
                                textAlign: "center",
                                padding: "10px"
                            }}
                        >
                            {lowerSectionProps.title}
                        </Typography>
                    </div>
                    <div className="pfs-area customize-scrollbar">
                        {upperSectionProps?.selectedItems?.[selectedMatter]?.map((item, index) => {
                            return (
                                <>
                                    <Box key={`${selectedMatter}-${item.id}`} sx={{display: "flex", alignItems: "center", justifyContent: "left"}}>
                                        <Checkbox
                                            size="small"
                                            checked={checkedForms?.[selectedMatter]?.[item.id] || false}
                                            onChange={() => {
                                                setCheckedForms((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        [selectedMatter]: {
                                                            ...prevState?.[selectedMatter],
                                                            [item.id]: !prevState?.[selectedMatter]?.[item.id]
                                                        }
                                                    };
                                                });
                                            }}
                                        />
                                        <Box
                                            className={`customize-chip orange-chip text-center ${
                                                lowerSectionProps?.setColor ? lowerSectionProps.setColor : ""
                                            } ${lowerSelectedItems === item.id ? "selected" : ""}`}
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="left"
                                            onClick={() => {
                                                setUpperSectionProps((prevState) => ({...prevState, selectedForm: upperSectionProps?.selectedItems?.[selectedMatter]?.[index].id}));
                                                setLowerSelectedItems(upperSectionProps.selectedItems?.[selectedMatter]?.[index].id);
                                                setSelectedForm(upperSectionProps.selectedItems?.[selectedMatter]?.[index].id);
                                            }}
                                            sx={{p: 1, cursor: "pointer"}}
                                        >
                                            {item.form_code}
                                            <Box flexGrow={1}/>
                                            <span
                                                style={{color: "black"}}
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    handleDelete(null, item.id);
                                                }}
                                            >
                                                X
                                            </span>
                                        </Box>
                                    </Box>
                                </>
                            );
                        })}
                    </div>
                </Div>
            )}
            <DeleteModal deleteModalOpen={deleteModalOpen} confirmDelete={confirmDelete} setConfirmDelete={setConfirmDelete} setDeleteModalOpen={setDeleteModalOpen} deleteLoading={deleteLoading}/>
        </Div>
    );
};

export default PreviewGeneratedFormsSelected;